import React, { SyntheticEvent } from 'react';

import { trackEvent } from '../../../helpers/analytics/trackEvent';
import { EventMykissCardClicked } from '../../../interfaces/events';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  to: string;
  eventProperties: EventMykissCardClicked['properties'];
  className?: string;
  linkClassName?: string;
  withDefaults?: boolean;
  disabled?: boolean;
  onClick?: (event: SyntheticEvent) => void;
}

export const LinkCard = ({
  disabled,
  to,
  eventProperties,
  linkClassName = '',
  className = '',
  withDefaults = true,
  onClick,
  ...rest
}: IProps) => (
  <InternalLink
    disabled={disabled}
    to={to}
    data-testid="LinkCard"
    variant="disabled" // fix in FIB-37696
    onClick={(e: SyntheticEvent) => {
      if (onClick) {
        onClick(e);
      }
      void trackEvent({
        name: 'mykiss_card_clicked',
        properties: eventProperties,
      });
    }}
    className={linkClassName}
  >
    <div className={`${withDefaults ? 'group h-full' : ''} ${className}`} {...rest} />
  </InternalLink>
);
